import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";

import { useStyles } from "./SystemUpdateModal.styles";
import isCordova from "../../../helpers/cordova-check";
import { isAndroid, isIos } from "../../../helpers/device-check";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/spiking-stocks-trading-ai-data/id1081721327?l=vi";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.spiking.spike.android";

const AppRatingModal = (props) => {
  const { show, onYes, onNo } = props;
  const classes = useStyles();

  const handleYes = () => {
    if (isCordova() && window.cordova?.InAppBrowser) {
      const url = isIos() ? APP_STORE_URL : isAndroid() ? PLAY_STORE_URL : APP_STORE_URL;
      window.cordova.InAppBrowser.open(url, "_system");
    } else {
      window.open(APP_STORE_URL, "_blank");
    }
    onYes?.();
  };

  const handleNo = () => {
    onNo?.();
  };

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      open={show}
      onClose={handleNo}
      aria-labelledby="app-rating-dialog-title"
      aria-describedby="app-rating-dialog-description"
    >
      <Box
        bgcolor="background.charcoal"
        pt={8}
        pb={6.5}
        px={4}
        borderRadius={20}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box mt={1} mb={4}>
          <Typography
            id="app-rating-dialog-title"
            className={classes.baseFontStyles}
            variant="h5"
            align="center"
          >
            Do you enjoy using Spiking?
          </Typography>
        </Box>
        <Box maxWidth={320} mb={5}>
          <Typography
            id="app-rating-dialog-description"
            align="center"
            className={classes.baseFontStyles}
            variant="body2"
          >
            Your feedback helps us improve. Would you mind rating us on the App Store?
          </Typography>
        </Box>
        <Box display="flex">
          <Button
            onClick={handleNo}
            variant="contained"
            color="primary"
            className={clsx(classes.button, classes.closeButton)}
            style={{ marginRight: 16 }}
          >
            Not Now
          </Button>
          <Button
            onClick={handleYes}
            variant="contained"
            color="primary"
            className={clsx(classes.button, classes.updateButton)}
          >
            Yes, Rate Us
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

AppRatingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onYes: PropTypes.func,
  onNo: PropTypes.func,
};

export default AppRatingModal;
